import { useQuery } from '@tanstack/react-query';
import apiClient from '../api/apiClient';

async function checkServiceReachable(): Promise<boolean> {
  try {
    await apiClient.get('/api/settings', { timeout: 3000 });
    return true;
  } catch {
    return false;
  }
}

export function useServiceStatus() {
  return useQuery({
    queryKey: ['service-status'],
    queryFn: checkServiceReachable,
    retry: false,
    staleTime: 30_000,
  });
}
